import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
// 评论路由
export default [{
  //评论列表页
  path: '/comments/list/:projectId',
  name: 'comments',
  component: function component() {
    return import('@/pages/comments/list');
  }
  // meta: {
  //   keepAlive: true, // 需要被缓存
  // },
}, {
  //评论列表页
  path: '/comments/myList/:projectId',
  name: 'myComments',
  component: function component() {
    return import('@/pages/comments/myList');
  }
  // meta: {
  //   keepAlive: true, // 需要被缓存
  // },
}, {
  //评论编辑页
  path: '/comments/edit/:orderId',
  name: 'commentsEdit',
  component: function component() {
    return import('@/pages/comments/edit');
  }
}, {
  //评论详情页
  path: '/comments/detail/:commentId',
  name: 'commentsDetail',
  component: function component() {
    return import('@/pages/comments/detail');
  }
}, {
  //评论分享页
  path: '/comments/share/:commentId',
  name: 'commentsShare',
  component: function component() {
    return import('@/pages/comments/share');
  }
}];